export { default } from "./loading-skeleton";
